<template>
    <div class="row">
        <div class="col-xxl-2 col-xl-3 border-end border-end-xl">
            <aside class="sidebar sticky-lg-top sticky-pernet">
                <div class="btn w-100 btn-secondary fw-bold mb-2" style="cursor:initial;">Affiner votre recherche</div>
                <button type="reset" class="btn w-100 btn-default" v-on:click="resetFilters()"><i class="fas fa-times small"></i> Réinitialiser les filtres</button>

                <div class="filters">
                    <ul class="list-unstyled">
                        <li>
                            <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#promo" role="button" aria-expanded="true" aria-controls="promo">
                                <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                                Promos / Nouveautés
                            </span>
                            <ul class="collapse list-unstyled show" id="promo">
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" value="" id="nouveautes"  v-model="selected.nouveautes">
                                        <label class="form-check-label" for="nouveautes">
                                            Nouveautés
                                        </label>
                                    </div>
                                </li>
                            </ul>
                            <!--<span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#categories" role="button" aria-expanded="true" aria-controls="categories">
                                    <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                                    Catégories
                                </span>-->
                            <ul class="collapse list-unstyled" id="categories" v-for="(category, index) in categories">
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"  :value="category.id"  :id="'category'+index" v-model="selected.categories">
                                        <label class="form-check-label" :for="'category' + index">
                                            {{ category.name }}
                                        </label>
                                    </div>
                                </li>
                            </ul>

                            <span class="w-100 border-bottom d-block pb-1 pt-3 text-uppercase fw-bold show" data-bs-toggle="collapse" href="#packagings"
                                  role="button" aria-expanded="true" aria-controls="packagings">
                     <span class="badge badge-pill bg-secondary"><i class="fas fa-plus"></i></span>
                     Conditionnement
                 </span>
                            <ul class="collapse list-unstyled" id="packagings" v-for="(packaging, index) in packagings">
                                <li>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox"  :value="packaging.code"  :id="'packaging'+index" v-model="selected.packagings">
                                        <label class="form-check-label" :for="'packaging' + index">
                                            {{ packaging.label }}
                                        </label>
                                    </div>
                                </li>
                            </ul>

                        </li>
                    </ul>
                </div>
            </aside>
        </div>

        <div class="col-xxl-10 col-xl-9">

            <div class="heading_catalogue mb-4">
                <h1 class="h3 fw-bold">{{ categoryname }}</h1>
                <hr>
                <!--<div class="row">
                    <div class="col-md-3">
                        <div class="form-inline">
                            <label for="sort" class="form-label small fw-bold">Trier par :</label>
                            <select name="sort" id="sort" class="form-control form-control-sm">
                                <option value="">Sélectionnez</option>
                                <option value="asc">Prix Croissant</option>
                                <option value="desc">Prix Décoissant</option>
                                <option value="new">Nouveautés</option>
                            </select>
                        </div>
                    </div>
                </div>-->
            </div>

            <div :class="{'loading': loading}">
                <div class="products row" >

                    <nav aria-label="course" class="navigation-grille">
                        <ul class="pagination">
                            <li class="page-item" :class="{ 'disabled': meta.current_page ===1 }">
                                <a class="page-link" href="#" @click.prevent="switched(meta.current_page - 1)">
                    <span>
                        &laquo;
                    </span>
                                </a>
                            </li>
                            <li class="page-item" :class="{ 'active': meta.current_page === x }" v-for="x in meta.last_page">
                                <a class="page-link" href="#" @click.prevent="switched(x)">{{ x }}</a>
                            </li>
                            <li class="page-item" :class="{ 'disabled': meta.current_page === meta.last_page }">
                                <a class="page-link" href="#" @click.prevent="switched(meta.current_page + 1)">
                    <span>
                        &raquo;
                    </span>
                                </a>
                            </li>
                        </ul>
                    </nav>

                    <shop-item v-for="item in products" :item="item" :guest="guest" :key="item.id">
                    </shop-item>

                    <nav aria-label="course" class="navigation-grille">
                        <ul class="pagination">
                            <li class="page-item" :class="{ 'disabled': meta.current_page ===1 }">
                                <a class="page-link" href="#" @click.prevent="switched(meta.current_page - 1)">
                    <span>
                        &laquo;
                    </span>
                                </a>
                            </li>
                            <li class="page-item" :class="{ 'active': meta.current_page === x }" v-for="x in meta.last_page">
                                <a class="page-link" href="#" @click.prevent="switched(x)">{{ x }}</a>
                            </li>
                            <li class="page-item" :class="{ 'disabled': meta.current_page === meta.last_page }">
                                <a class="page-link" href="#" @click.prevent="switched(meta.current_page + 1)">
                    <span>
                        &raquo;
                    </span>
                                </a>
                            </li>
                        </ul>
                    </nav>


                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'Product-Category',
        props: ['categoryname','categoryid','user_id'],
        data: function () {
            return {
                loading: true,
                guest: true,
                page: 1,
                meta: null,
                products: [],
                categories: [],
                packagings: [],
                promotions: false,
                nouveautes: false,
                selected: {
                    categories: [this.categoryid],
                    packagings: [],
                }
            }
        },
        mounted() {
            this.loadProducts();
            this.loadPackaging();
        },
        created() {

        },
        watch: {
            selected: {
                handler: function () {
                    this.page = 1;
                    this.loadSearchProducts();
                },
                deep: true
            }
        },
        methods: {
            loadProducts: function() {
                axios.get('/api/category-public', {
                    params: {
                        categories: this.selected.categories
                    }
                })
                    .then((response) => {
                        this.products = response.data.data;
                        this.loading = false;
                        this.meta = response.data.meta;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            loadCategories: function() {
                axios.get('/api/categories', {
                })
                    .then((response) => {
                        this.categories = response.data.data;
                        this.loading = false;
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            loadPackaging: function() {
                axios.get('/api/packaging', {
                })
                    .then((response) => {
                        this.packagings = response.data.data;
                        this.loading = false;
                    })
                    .catch(function (error) {

                    });
            },
            loadSearchProducts: function()
            {
                let dataPass = {...this.selected, 'keyword' : this.keyword, 'page': this.page};
                axios.get('/api/search-public-products',{
                    params: dataPass
                })
                    .then((response) => {
                        this.products = response.data.data;
                        this.loading = false;
                        this.meta = response.data.meta;
                        let anchor = document.querySelector('#pernet-app');
                        anchor.scrollIntoView(
                            {
                                behavior: 'smooth'
                            }
                        );

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            switched(pageVal){
                this.page = pageVal;
                this.loadSearchProducts();
                let anchor = document.querySelector('#pernet-app');
                anchor.scrollIntoView(
                    {
                        behavior: 'smooth'
                    }
                );
            },
            resetFilters()
            {
                this.selected.packagings = [];
                this.selected.nouveautes = false;
                this.selected.promotions = false;
            }
        }
    }
</script>
